import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
    persist: {
        enabled: true
    },
    state: () => ({
        token: null,
        user: {
            avatar: null,
            nickName: null,
            tenantNo: null,
        },
        plants: [],
    }),
    actions: {
        setToken(token) {
            this.token = token
        },
        clearToken() {
            this.token = null
            this.user = {}
        },
        setUser(user) {
            this.user = user
        },
    },
});